
export class googleRequest {

    googleKey: string
}